/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Start_LabelInputs */

const en_audio_recorder_start_label = /** @type {(inputs: Audio_Recorder_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

const fr_audio_recorder_start_label = /** @type {(inputs: Audio_Recorder_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Début`)
};

const de_audio_recorder_start_label = /** @type {(inputs: Audio_Recorder_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

const it_audio_recorder_start_label = /** @type {(inputs: Audio_Recorder_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizio`)
};

const ru_audio_recorder_start_label = /** @type {(inputs: Audio_Recorder_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начинать`)
};

const es_audio_recorder_start_label = /** @type {(inputs: Audio_Recorder_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comenzar`)
};

const zh_cn2_audio_recorder_start_label = /** @type {(inputs: Audio_Recorder_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始`)
};

const ja_audio_recorder_start_label = /** @type {(inputs: Audio_Recorder_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`始める`)
};

const hi_audio_recorder_start_label = /** @type {(inputs: Audio_Recorder_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरू`)
};

const pt_pt2_audio_recorder_start_label = /** @type {(inputs: Audio_Recorder_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar`)
};

/**
* | output |
* | --- |
* | "Start" |
*
* @param {Audio_Recorder_Start_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_start_label = /** @type {((inputs?: Audio_Recorder_Start_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Start_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_start_label(inputs)
	if (locale === "de") return de_audio_recorder_start_label(inputs)
	if (locale === "it") return it_audio_recorder_start_label(inputs)
	if (locale === "ru") return ru_audio_recorder_start_label(inputs)
	if (locale === "es") return es_audio_recorder_start_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_start_label(inputs)
	if (locale === "ja") return ja_audio_recorder_start_label(inputs)
	if (locale === "hi") return hi_audio_recorder_start_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_start_label(inputs)
	return en_audio_recorder_start_label(inputs)
});